module.exports = __webpack_public_path__ + "img/title.6ad527a2.png";